<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box no-display">
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
            <v-toolbar flat class="toolbar" dense justify="center">
                <v-toolbar-title align="center">
                    <strong>
                        Faculty Time Table
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row class="no-display" dense justify="center">
                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required color="#0F2027" v-model="org" :items="org_list"
                        item-text="name" return-object label="Organization" outlined @click="clear()"
                        @change="getAy()"></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required color="#0F2027" v-model="ay" :items="academic_year_list"
                        item-text="ay" return-object label="Academic Year" @click="clear()" outlined></v-autocomplete>
                </v-col>
                <!-- <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense multiple required color="#0F2027" v-model="stream_id" :items="stream_list" item-text="str" return-object  label="Stream" @click="clear()" outlined></v-autocomplete>
                </v-col> -->
                <v-col cols="12" md="3" sm="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded outlined dense color="#0F2027" v-model="inst" :items="inst_list"
                        item-text="name" return-object label="Select Employee" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="ay && org && inst">
                    <v-btn class="mt-6 button" :loading="fetch_loader" @click="show_tt = true">Fetch / Generate</v-btn>
                </v-col>
            </v-row>
        </v-card>
        <faculty-time-table v-if="show_tt==true" :org="org.id" :uid="inst.uid" :ay="ay.ay"></faculty-time-table>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import GetFacultyTT from './GetFacultyTT'
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
    export default {
          components:{
            'faculty-time-table': GetFacultyTT,
            Breadcrumbs
            },
        data() {
            return {
                loader: false,
                overlay: false,
                color: "",
                snackbar: false,
                // extraBreadcrumbItems: [
                  

                // ],
                breadcrumbClass: "breadcrumb-style1",
                search: null,
                snackbar_msg: null,
                current_academic_year: null,
                stream: null,
                header: null,
                standard_list: null,
                dision_list: null,
                org_list: null,
                display_data: false,
                org_data_list: [],
                division_list: [],
                dialog: false,
                org_data: [],
                fetch_loader: false,
                header_list: [],
                org:null,
                show:false,
                std_id:null,
                stream_id:null,
                stream_list:[],
                ay:null,
                academic_year_list: null,
                inst_list:[],
                inst:null,
                show_tt:false,
            }
        },
        watch: {
        
        },
        methods: {
            convert(date) {
                var datearray = date.split("-");
                var newdate = datearray[2] + "/" + datearray[1] + "/" + datearray[0];
                return newdate;
            },
             print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },
             formatDate(date) {
                if (!date) return null;
                const [year, month, day] = date.split("-");
                return `${day}/${month}/${year}`;
            },
            parseDate(date) {
                if (!date) return null;
                const [month, day, year] = date.split("/");
                return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
            },
            
            clear() {
                this.org_data_list = [];
                this.show_tt = false
            },
            getAy() {
                this.academic_year_list = null,
                this.standard_list = null,
                this.ay = null
                this.std_id = null,
                this.stream_list = null
                this.stream_id = [],
                this.div = null
                this.inst_list = [],
                this.inst=null
                const data = {
                    org: this.org.id,
                };
                axios
                    .post("/Management/getAy", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.academic_year_list = res.data.academic_year_list;
                            this.stream_list = res.data.stream_list
                            this.inst_list = res.data.inst_list
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!");
                    })
                    .finally(() => {
                        //close loader
                    });
            },
           
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                axios
                    .post("/Management/getOrg_without_all")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.org_list = res.data.org_list;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!");
                    })
                    .finally(() => {
                        //close loader
                    });
            },
        },
        mounted() {
            this.onload();
        },
    };
</script>
<style scoped>
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
        font-size: small;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }
      @media print {
        header,
        footer,
        nav,
        date {
            display: none !important;
        }
        img {
            width: 100% !important;
        }
        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }
        @page {
            margin-top: none;
            padding-top: none;
            size: 15.5in 15.5in;
        }
        thead {
            text-align: center !important;
            margin: none;
            padding: 1rem !important;
            font-size: xx-large !important;
            font-weight: bold !important;
            border-bottom: 1px solid black;
            border: 1px solid black;
        }
    }
</style>
